import { CheckBox, CheckBoxProps } from '@design/components/checkbox/CheckBox';

import styles from './RowSelectionCheckbox.module.scss';

interface RowSelectionCheckboxProps extends Omit<CheckBoxProps, 'label'> {}

export const RowSelectionCheckbox = (props: RowSelectionCheckboxProps) => {
  return <CheckBox className={styles.styledCheckBox} {...props} label="" />;
};
